export const RETURN_DETAILS_MODAL_OPEN = 'RETURN_DETAILS_MODAL_OPEN';
export const openReturnDetailModal = (returnId, modalId, returnDetailModalId) => {
  return {
    type: RETURN_DETAILS_MODAL_OPEN,
    returnId,
    modalId,
    returnDetailModalId,
  };
};

export const RETURN_DETAILS_GO_TO_ROUTE = 'RETURN_DETAILS_GO_TO_ROUTE';
export const goToReturnDetails = (fulfillmentId) => ({
  type: RETURN_DETAILS_GO_TO_ROUTE,
  fulfillmentId,
});

export const RETURN_DETAILS_MODAL_CLOSED = 'RETURN_DETAILS_MODAL_CLOSED';
export const closedReturnDetailModal = (returnDetailModalId) => {
  return {
    type: RETURN_DETAILS_MODAL_CLOSED,
    returnDetailModalId,
  };
};

export const GET_RETURN_DETAILS_REQUEST = 'GET_RETURN_DETAILS_REQUEST';
export const requestReturnDetails = (returnDetailModalId) => {
  return {
    type: GET_RETURN_DETAILS_REQUEST,
    returnDetailModalId,
  };
};

export const GET_RETURN_DETAILS_SUCCESS = 'GET_RETURN_DETAILS_SUCCESS';
export const getReturnDetailsSuccess = (returnShipment, returnDetailModalId) => {
  return {
    type: GET_RETURN_DETAILS_SUCCESS,
    returnShipment,
    returnDetailModalId,
  };
};

export const RETURN_DETAILS_OPEN_SET_RECEIVED_DATE_MODAL = 'RETURN_DETAILS_OPEN_SET_RECEIVED_DATE_MODAL';
export const openSetReceivedDateModal = (fulfillmentId) => ({
  type: RETURN_DETAILS_OPEN_SET_RECEIVED_DATE_MODAL,
  fulfillmentId,
});

export const RETURN_DETAILS_OPEN_UPDATE_RECEIVED_DATE_MODAL = 'RETURN_DETAILS_OPEN_UPDATE_RECEIVED_DATE_MODAL';
export const openUpdateReceivedDateModal = (fulfillmentId) => ({
  type: RETURN_DETAILS_OPEN_UPDATE_RECEIVED_DATE_MODAL,
  fulfillmentId,
});
export const RETURN_DETAILS_MARK_AS_RECEIVED_SUCCESS = 'RETURN_DETAILS_MARK_AS_RECEIVED_SUCCESS';
export const markAsReceivedSuccess = (fulfillmentId) => ({
  type: RETURN_DETAILS_MARK_AS_RECEIVED_SUCCESS,
  fulfillmentId,
});
